<template>
  <div>
    <v-row class="mb-3" align="center"
      justify="center">
        <v-col lg="2" sm="6" cols="12">
          <v-select
            :items="statusFillter"
            :label="$t('Status')"
            v-model="configDatatale.paramsRequest.status"
            :item-text="__attr"
            outlined
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col lg="3" sm="6" cols="12">
          <v-autocomplete
            auto-select-first
            :label="$t('Manager')"
            :items="selectUsers"
            :placeholder="$t('Select an option')"
            v-model="configDatatale.paramsRequest.user_id"
            clearable
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-col lg="3" sm="5" cols="12">
          <v-row>
             <v-col md="6">
                <datepicker v-model="configDatatale.paramsRequest.from_date" :label="$t('From date')"/>
             </v-col>
             <v-col md="6">
               <datepicker v-model="configDatatale.paramsRequest.to_date" :label="$t('To date')"/>
             </v-col>
          </v-row>
        </v-col>
        <v-col lg="3" sm="5" cols="12">
          <v-text-field
            v-model="configDatatale.paramsRequest._search"
            append-icon="mdi-magnify"
            :label="$t('Key word')"
            outlined
            dense
            hide-details
            @keydown.enter="handleSearch($event)"
          />
        </v-col>
        <v-col lg="1" sm="2" cols="12">
          <v-btn
            color="primary"
            medium
            outlined
            @click="handleSearch($event)"
          >
            {{ $t('Search') }}
          </v-btn>
        </v-col>
    </v-row>
    <datatable ref="projectsDatatable" :config="configDatatale"/>

    <dialog-admin-review ref="adminReview" @submit="submittedReviewed"/>
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import Datepicker from '@/components/Datepicker'
import DialogAdminReview from './components/DialogAdminReview'

import { get, call } from 'vuex-pathify'

export default {
  name: 'ProjectEvaluationIndex',
  components: {
    Datatable,
    Datepicker,
    DialogAdminReview
  },
  data: (vm) => ({
    configDatatale: {
      url: '/api/admin/projects/datatable',
      queryBuilder: {
        _include: ['manager:id,name', 'review']
      },
      operations: [
        {
          color: 'primary',
          text: 'Review',
          icon: 'mdi-eye',
          method: function (item) {
            vm.$refs.adminReview.setData(item)
            return false
          }
        }
      ],
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id'
        },
        {
          text: vm.$t('Code'),
          data: 'code',
          name: 'code',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.id}} }">${item[column]}</router-link>`
          }
        },
        {
          text: vm.$t('Name'),
          data: 'name',
          name: 'name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.id}} }">${item[column]}</router-link>`
          }
        },
        {
          text: vm.$t('Type'),
          data: 'type',
          name: 'type',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return vm.__attr(item[column])
          }
        },
        {
          text: vm.$t('Manager'),
          data: 'manager.name',
          name: 'manager.name',
          searchable: true,
          orderable: false
        },
        {
          text: vm.$t('Status'),
          data: 'status',
          name: 'status',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return vm.__attr(item[column])
          }
        },
        {
          text: vm.$t('AVG rate'),
          data: 'review.avg',
          name: 'review.avg',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return item.review?.avg || '---'
          }
        },
        {
          text: vm.$t('Value'),
          data: 'value',
          name: 'value'
        },
        {
          text: vm.$t('Points'),
          data: 'points',
          name: 'points'
        },
        {
          text: vm.$t('Operations'),
          data: '_operations',
          name: null,
          searchable: false,
          orderable: false
        }
      ],
      setting: {
        displaySearchInput: false,
        operationStyle: 'ProjectEvaluation',
        actions: {
          review: (item) => {
            vm.$refs.adminReview.setData(item)
            return false
          }
        }
      },
      paramsRequest: {
        status: '',
        from_date: null,
        to_date: null,
        user_id: null,
        _search: null
      }
    }
  }),
  computed: {
    ...get('common', [
      'project_status'
    ]),
    selectUsers: get('user/selectUsers'),
    statusFillter() {
      return [
        {
          text: 'All',
          value: ''
        },
        ...this.project_status
      ]
    }
  },
  mounted() {
    this.fetchAllUsers()
  },
  methods: {
    fetchAllUsers: call('user/all'),

    handleSearch(e) {
      e.preventDefault()
      const filter = {
        ...this.configDatatale.paramsRequest
      }
      this.$refs.projectsDatatable.setParamsRequest(filter)
      this.$refs.projectsDatatable.fetchData()
      return false
    },

    submittedReviewed(project) {
      this.$refs.projectsDatatable.setDataById(project.id, project)
    }
  }
}
</script>
